// Copyright (c) Proto Labs, Inc. All Rights Reserved.
export class TokenManagerTimeoutMonitor {
    constructor(logger, settings, state, userManager, disableTimer = false) {
        this.interval = 0;
        this.monitoring = false;
        this.logger = logger;
        this.settings = settings;
        this.state = state;
        this.userManager = userManager;
        if (this.settings.monitorTimeout && !disableTimer) {
            this.startMonitor();
        }
    }
    get timeoutAt() {
        return this.state.timeoutAt;
    }
    isTimedOut() {
        if (!this.state.timeoutAt) {
            return false;
        }
        return this.state.timeoutAt < this.getBaseTimeInSeconds();
    }
    isFlagged() {
        const exists = document.cookie.includes('protolabs_timeout=true');
        this.logger.debug(`TokenManagerTimeoutMonitor.isFlagged: cookie exists = ${exists}.`);
        return exists;
    }
    update(userTimeoutSeconds) {
        this.state.timeoutAt = this.getBaseTimeInSeconds() + userTimeoutSeconds;
        this.logger.debug(`TokenManagerTimeoutMonitor.update: updating timeoutAt to ${this.state.timeoutAt}.`);
        this.state.save();
    }
    clear() {
        this.logger.debug('TokenManagerTimeoutMonitor.clear: clearing timeout date.');
        this.state.clear();
    }
    async timeout() {
        this.logger.debug('TokenManagerTimeoutMonitor.timeout: starting timeout.');
        this.clear();
        this.setCookie();
        await this.userManager.signoutRedirectAsync();
    }
    getBaseTimeInSeconds() {
        return Math.round(Date.now() / 1000);
    }
    startMonitor() {
        this.logger.debug('TokenManagerTimeoutMonitor.monitor: setting the interval.');
        this.interval = window.setInterval(async () => {
            if (this.isTimedOut()) {
                clearInterval(this.interval);
                this.monitoring = false;
                await this.timeout();
            }
        }, this.settings.timeoutMonitorIntervalMilliseconds);
        this.monitoring = true;
    }
    setCookie() {
        this.logger.debug('TokenManagerTimeoutMonitor.setCookie: setting 20s timeout cookie.');
        const d = new Date();
        d.setTime(d.getTime() + 20000);
        document.cookie = `protolabs_timeout=true;path=/;expires=${d.toUTCString()}`;
    }
}
//# sourceMappingURL=TokenManagerTimeoutMonitor.js.map